import { Card } from "@blueprintjs/core";
import * as React from "react";

const GenericLinkCard = ({
  header,
  onMouseOver,
  onMouseLeave,
  link,
  metadata,
  className = "",
}: {
  header: React.ReactNode;
  className?: string;
  link: React.ReactNode;
  metadata: React.ReactNode;
  onMouseOver?: () => void;
  onMouseLeave?: () => void;
}) => {
  return (
    <Card
      className={`generic-link-card ${className}`}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
      elevation={1}
    >
      <div className="generic-link-card__header">{header}</div>
      <div className="generic-link-card__body">
        <div className="generic-link-card__metadata">{metadata}</div>
        <div className="generic-link-card__view">{link}</div>
      </div>
    </Card>
  );
};

export default GenericLinkCard;
